<template>
  <div class="more-info-wrapper">
    <!-- 完善信息、药品图片暂时隐藏，商品编码保留 -->
    <!--
    <div class="title">
      完善信息
      <span class="tips">填完后，选用药品更快捷</span>
    </div>
    <el-form-item label="使用频次" prop="usageFrequencyName">
      <el-select class="controller" v-model="usageFrequencyCode" placeholder="请选择" :disabled="disabled" clearable>
        <el-option
          v-for="item in usageFrequencyNames"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="每次用量" prop="perNum">
      <el-input class="controller" v-model="perNum" placeholder="请输入" :disabled="disabled"></el-input>
    </el-form-item>
    <el-form-item label="用量单位" prop="perUnit">
      <el-select class="controller" v-model="perUnit" placeholder="请选择" :disabled="disabled" clearable>
        <el-option v-for="unit in perUnits" :key="unit.value" :label="unit.label" :value="unit.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="服用天数" prop="takingDay">
      <el-input class="controller" v-model="takingDay" placeholder="请输入" :disabled="disabled"></el-input>
    </el-form-item>
    -->
    <el-form-item v-if="showDrugCode" label="商品编码" prop="drugCode">
      <el-input
        class="controller"
        v-model="drugCode"
        placeholder="请输入（支持条码枪）"
        :disabled="disabled"
        clearable
      ></el-input>
    </el-form-item>
    <!--
    <el-form-item label="药品图片">
      <div class="drug-picture">
        <uploadImage
          :image="thumbnail"
          text="请上传药品正面"
          :http-request="e => uploadImage(e, 'thumbnail')"
          :disabled="disabled"
          @remove="() => removeImage('thumbnail')"
        />
        <uploadImage
          :image="barcodePic"
          text="请上传有药品条形码的侧面"
          :http-request="e => uploadImage(e, 'barcodePic')"
          :disabled="disabled"
          @remove="() => removeImage('barcodePic')"
        />
        <div class="example" v-if="!disabled">
          <div class="title">
            <i class="el-icon-warning-outline"></i>
            <span class="text">图片示例</span>
          </div>
          <div class="content">
            <div class="img" />
          </div>
        </div>
      </div>
    </el-form-item>
    -->
  </div>
</template>

<script>
import Fetch from '@/api';
import uploadImage from './uploadImage';
import { mapState } from 'vuex';

export default {
  name: 'moreInfo',
  components: {
    uploadImage
  },
  props: {
    moreInfo: {
      type: Object
    },
    usageFrequencyNames: {
      type: Array
    },
    perUnits: {
      type: Array
    },
    mode: {
      type: String
    }
  },
  computed: {
    ...mapState('drugsManagement', ['showDrugCode']),
    disabled() {
      return this.mode === 'view';
    },
    usageFrequencyCode: {
      get() {
        if (this.moreInfo.usageFrequencyCode) {
          return this.moreInfo.usageFrequencyCode;
        }

        const option = this.usageFrequencyNames.find(item => item.label === this.moreInfo.usageFrequencyName);
        return option ? option.value : '';
      },
      set(val) {
        const option = this.usageFrequencyNames.find(item => item.value === val);
        this.$emit('change', 'usageFrequencyName', option ? option.label : '');
        this.$emit('change', 'usageFrequencyCode', option ? option.value : '');
      }
    },
    perNum: {
      get() {
        return this.moreInfo.perNum;
      },
      set(val) {
        this.$emit('change', 'perNum', val);
      }
    },
    drugCode: {
      get() {
        return this.moreInfo.drugCode;
      },
      set(val) {
        this.$emit('change', 'drugCode', val);
      }
    },
    perUnit: {
      get() {
        return this.moreInfo.perUnit;
      },
      set(val) {
        this.$emit('change', 'perUnit', val);
      }
    },
    takingDay: {
      get() {
        return this.moreInfo.takingDay;
      },
      set(val) {
        this.$emit('change', 'takingDay', val);
      }
    },
    thumbnail: {
      get() {
        return this.moreInfo.thumbnail;
      },
      set(val) {
        console.log(val, 'val');
        this.$emit('change', 'thumbnail', val);
      }
    },
    barcodePic: {
      get() {
        return this.moreInfo.barcodePic;
      },
      set(val) {
        this.$emit('change', 'barcodePic', val);
      }
    }
  },
  methods: {
    uploadImage(e, field) {
      const file = e.file;
      const fd = new FormData();

      fd.append(
        'uploadParam',
        JSON.stringify({ appName: 'drugstore-prescription-admin-pc', scene: 'prescription_file' })
      );
      fd.append('fileStream', file);
      Fetch.uploadImage(fd).then(res => {
        const {
          data: { url }
        } = res;

        this[field] = url;
      });
    },
    removeImage(field) {
      this[field] = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.more-info-wrapper {
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: bold;
    color: #242424;

    .tips {
      display: inline-flex;
      align-items: center;
      margin-left: 8px;
      padding: 0 6px;
      height: 18px;
      font-size: 12px;
      color: #fff;
      background: linear-gradient(141deg, #e6d9b5 0%, #bfa262 100%);
      border-radius: 8px 8px 8px 0;
      transform: translateY(-3px);
    }
  }

  .controller {
    width: 176px;

    &.lg {
      width: 483px;
    }
  }

  .drug-picture {
    display: flex;

    .upload-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 272px;
      height: 184px;
      border-radius: 4px;
      border: 1px solid #f2f2f2;

      &:hover {
        border-color: #bdbdbd;
      }

      .upload {
        display: flex;
        flex-direction: column;
        color: #bfbfbf;
        font-size: 14px;
      }
    }
  }

  .example {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 16px;
    width: 272px;
    height: 184px;

    .title {
      font-size: 14px;
      color: #707070;

      i {
        margin-right: 9px;
      }

      .text {
        line-height: 1;
      }
    }

    .content {
      position: relative;
      width: 278px;
      height: 148px;
      background-color: #f5f5f5;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 34px;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid #f5f5f5;
        transform: translateY(-100%);
      }

      .img {
        width: 100%;
        height: 100%;
        background-image: url('~@/assets/img/drug_example_pic.png');
        background-size: 254px 111px;
        background-position: center center;
        background-repeat: no-repeat;
      }
    }
  }
}
</style>
